module.exports = __webpack_public_path__ + "static/media/logo-silestone-xm.d304db8d.svg";